import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from "rxjs/Observable";

import { CrudService } from '../../core';
import { Administrator } from './administrator.model';

@Injectable()
export class AdministratorService extends CrudService {
  getRootUrl() : string {
    return 'users';
  }

  save(administrator: Administrator) : Observable<Administrator> {
    return super.save(administrator);
  }

  saveMultiple(administrators: Array<Administrator>) : Observable<Array<Administrator>> {
    return super.saveMultiple(administrators);
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/administrators/shared/administrator.service.ts